<template>
    <SensorsContainer v-if="currentDamSelectedId"></SensorsContainer>
    <div class="d-flex justify-content-center align-items-center" v-else>
        <b-spinner class="m-5" variant="primary"></b-spinner>
    </div>

</template>

<script>
    // mixins
    import getDamDataMixin from "../mixins/getDamDataMixin";
    // utils
    import {setDocumentTitle} from "../utils/i18n/document";
    // vuex
    import {mapGetters} from "vuex";
    // components
    import SensorsContainer from "../components/sensors/SensorsContainer";

    export default {
        name: "SensorsView",
        mixins: [getDamDataMixin],
        components: {
            SensorsContainer
        },
        async mounted() {
            setDocumentTitle(this.$t("sensors-page.title"));
        },
        computed: {
            ...mapGetters(['getDamData'])
        },
    }
</script>
